var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-date',{attrs:{"value":_vm.value,"text":_vm.field.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }